import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import {
  Form,
  Alert,
  FormGroup,
  FormFeedback,
  FormText,
  Input,
  Button,
  Label,
} from 'reactstrap';
import { CreateRateMutation } from './query';

const CreateRateGQL = compose(
  graphql(CreateRateMutation, { name: 'createrate' })
);

class CreateRate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      operator: 'airtel',
      rate: '',
      error: '',
    };
  }
  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  submitHandler = async event => {
    event.preventDefault();
    if (!event.target.checkValidity()) {
      // form is invalid! so we do nothing
      event.stopPropagation();
      event.target.classList.add('was-validated');
      return;
    }
    try {
      const newrate = await this.props.createrate({
        variables: {
          name: this.state.operator,
          rate: this.state.rate,
        },
      });
      this.setState({
        error: '',
      });
      this.props.onNewRate(newrate.data.createrate);
    } catch (error) {
      this.setState({
        error: error.message,
      });
    }
  };
  render() {
    return (
      <div>
        {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
        <Form noValidate onSubmit={e => this.submitHandler(e)}>
          <FormGroup>
            <Label for="operator">Select Operator</Label>
            <Input
              type="select"
              name="operator"
              id="operator"
              value={this.state.operator}
              onChange={e => this.onChange(e)}
            >
              <option value="airtel">Airtel</option>
              <option value="orange">Orange</option>
              <option value="voda">Vodacom</option>
              <option value="africell">AfriCell</option>
            </Input>
            <FormText>Select operator to apply new rate</FormText>
          </FormGroup>
          <FormGroup>
            <Label for="rate">Enter Rate</Label>
            <Input
              type="number"
              name="rate"
              id="rate"
              required
              value={this.state.rate}
              onChange={e => this.onChange(e)}
            />
            <FormText>Rate to apply to all request</FormText>
            <FormFeedback>The rate is required</FormFeedback>
          </FormGroup>
          <div style={{ float: 'right' }}>
            <Button color="success">Create Rate</Button>
          </div>
        </Form>
      </div>
    );
  }
}

export default CreateRateGQL(CreateRate);



// WEBPACK FOOTER //
// ./src/views/Rates/createRate.js